module.exports = __webpack_public_path__ + "static/img/975_phase_function_Paper_Points.2a55667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/975_phase_function_Paper_Points.png
// module id = Lrng
// module chunks = 0